import { __awaiter } from "tslib";
import { Store as Client } from "@civic/identity-store-client";
import { mapResponse } from "./utils";
import { LIBRARY_VERSION } from "../version";
export class PublicIdentityStore {
    constructor(client, did) {
        this.client = client;
        this.did = did;
    }
    static create(did, civicIdentityStoreEndpoint) {
        const client = new Client({
            endpoint: civicIdentityStoreEndpoint,
            headers: {
                "X-Civic-Client-Version": LIBRARY_VERSION,
            },
        });
        return new PublicIdentityStore(client, did);
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.client.get(this.did);
                if (!res) {
                    return null;
                }
                const profile = res.contents
                    ? Object.assign(Object.assign({}, res.contents), { identifiers: res.identifiers }) : {};
                return mapResponse(profile);
            }
            catch (e) {
                return null;
            }
        });
    }
}
